var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.2381C6 10.7045 6 9.43774 6.49307 8.47004C6.92678 7.61883 7.61883 6.92678 8.47004 6.49307C9.43774 6 10.7045 6 13.2381 6H18.7619C21.2955 6 22.5623 6 23.53 6.49307C24.3812 6.92678 25.0732 7.61883 25.5069 8.47004C26 9.43774 26 10.7045 26 13.2381V18.7619C26 21.2955 26 22.5623 25.5069 23.53C25.0732 24.3812 24.3812 25.0732 23.53 25.5069C22.5623 26 21.2955 26 18.7619 26H13.2381C10.7045 26 9.43774 26 8.47004 25.5069C7.61883 25.0732 6.92678 24.3812 6.49307 23.53C6 22.5623 6 21.2955 6 18.7619V13.2381Z",
    fill: "#49021F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8515 11.8539V20.6195C12.8515 20.7113 12.8112 20.7572 12.7308 20.7571H11.1073C11.0356 20.7571 10.9999 20.7112 11 20.6195V11.8539C11 11.7806 11.0402 11.7439 11.1207 11.7438H12.7441C12.8057 11.7349 12.8602 11.7908 12.8515 11.8539Z",
    fill: "#FF3366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6547 20.8947C17.0371 20.9043 16.4253 20.7727 15.8635 20.5094C14.671 19.9433 14.1528 18.6904 14.1529 17.3994C14.1426 16.1117 14.8247 14.8847 15.9374 14.2758C16.7054 13.8394 17.6089 13.7285 18.4731 13.8079V11.097C18.4731 11.033 18.4999 11.0007 18.5536 11.0007H20.2441C20.2903 10.9939 20.3312 11.0359 20.3246 11.0833V19.2158C20.3246 19.5514 20.3578 19.8858 20.3783 20.2204C20.3816 20.2775 20.3485 20.3341 20.2977 20.358C19.8616 20.5445 19.4074 20.6829 18.9427 20.7708C18.5178 20.8512 18.0867 20.8927 17.6547 20.8947ZM18.4731 19.1883V15.4317C17.2532 15.0927 16.0579 16.0241 16.0581 17.3169C16.0286 18.6708 17.2358 19.5595 18.4731 19.1883Z",
    fill: "#FF3366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndesign);
export default __webpack_public_path__ + "static/media/indesign.b161e60ca46428042a3b8e94e51a86ec.svg";
export { ForwardRef as ReactComponent };